export default "__VITE_ASSET__CosEL1UH__"